import React from 'react';
import styled from '@emotion/styled';

const SkillsSection = styled.section`
  padding: 5.5rem 1.6rem 4.5rem;
  background-color: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.text};
  text-align: left;
`;

const Title = styled.h1`
  font-size: 2.7rem;
  margin-bottom: 0.6rem;
  letter-spacing: -0.03em;
`;

const SubText = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.textSecondary || '#888'};
  max-width: 700px;
  margin: 0 0 2.5rem;
  line-height: 1.6;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.6rem;
  justify-content: center;
`;

const Card = styled.div`
  background-color: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text};
  padding: 1.6rem;
  border-radius: 0;
  border: 1px solid ${({ theme }) => theme.line || 'rgba(12,12,12,0.12)'};
  text-align: left;

  h3 {
    font-size: 1.1rem;
    margin-bottom: 0.8rem;
    color: ${({ theme }) => theme.text};
    letter-spacing: 0.02em;
  }

  ul {
    list-style: none;
    padding-left: 0;
    margin: 0;

    li {
      font-size: 0.98rem;
      line-height: 1.55;
      color: ${({ theme }) => theme.text};
    }
  }
`;

function Skills() {
  return (
    <SkillsSection id="skills">
      <Title>Skills</Title>
      <SubText />
      <CardGrid>
        <Card>
          <h3>Front-end</h3>
          <ul>
            <li>React, Redux, JavaScript, CSS, HTML, Vite</li>
          </ul>
        </Card>
        <Card>
          <h3>Styling</h3>
          <ul>
            <li>Emotion, responsive layouts, design systems</li>
          </ul>
        </Card>
        <Card>
          <h3>Backend learning</h3>
          <ul>
            <li>Node.js, REST, data structures</li>
          </ul>
        </Card>
        <Card>
          <h3>Tools</h3>
          <ul>
            <li>Git, GitHub, Chrome DevTools</li>
          </ul>
        </Card>
        <Card>
          <h3>Other</h3>
          <ul>
            <li>Performance basics, debugging</li>
          </ul>
        </Card>
      </CardGrid>
    </SkillsSection>
  );
}

export default Skills;
